import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import Header from "../../layout/userheader";
import SideBar from "../usercomponent/usersidebar";
import UserHeader from "../usercomponent/userheader";

const User = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [showSiderbar, setShowSiderbar] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
  }, []);

  const { pathname } = useLocation();

  return (
    token && (
      <div
        className="
        grid grid-cols-4
        bg-admin
        dark:bg-[radial-gradient(circle_at_10%_0,#020617_0,#020617_40%,#020617_100%)]
        h-fit min-h-screen
      "
      >
        <aside
        className={`${
          showSiderbar ? "translate-x-0" : "-translate-x-full"
        } fixed xl:translate-x-0 w-64 z-10 h-[100vh] overflow-hidden transition-all duration-500`}
      >
          <SideBar setShowSiderbar={setShowSiderbar} />
        </aside>
        <main className="col-span-4 xl:ml-[256px] ml-0 transition-all duration-500 p-8 md:px-12 overflow-x-hidden overflow-y-auto">
          <section className="w-full h-16 items-center flex mb-16">
            <UserHeader setShowSiderbar={setShowSiderbar} />
          </section>
          <section>
            <Outlet />
          </section>
        </main>
      </div>
    )
  );
};

export default User;
